import { render, staticRenderFns } from "./ShopifyCart.vue?vue&type=template&id=173ed6e5&scoped=true&lang=pug&"
import script from "./ShopifyCart.vue?vue&type=script&lang=js&"
export * from "./ShopifyCart.vue?vue&type=script&lang=js&"
import style0 from "./ShopifyCart.vue?vue&type=style&index=0&id=173ed6e5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173ed6e5",
  null
  
)

export default component.exports